const initialState = [];

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'CONTEXTS_SUCCESS') {
        return action.payload.contexts;
    }

    return state;
}

export default reducer;
